import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Facebook, Instagram, Linkedin } from 'lucide-react';
import logoI7 from '../assets/logo-i7.png';
import { useToolTheme } from '@/contexts/ThemeContext';
import { motion } from 'framer-motion';

export default function Footer() {
  const { toolColors } = useToolTheme();

  const footerStyle = {
    backgroundColor: toolColors.primary,
    transition: 'background-color 0.5s ease-in-out'
  };

  return (
    <motion.footer 
      className="text-white py-4 mt-8"
      style={footerStyle}
      initial={{ backgroundColor: '#54075B' }}
      animate={{ backgroundColor: toolColors.primary }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-4">
        {/* Desktop Footer */}
        <div className="hidden md:grid md:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="flex flex-col items-center md:items-start">
            <img 
              src={logoI7}
              alt="Logo I7" 
              className="h-16 object-contain mb-4"
            />
            <p className="text-sm text-center md:text-left">
              Human & Entity Design - Optimisez votre énergie et alignez votre potentiel
            </p>
          </div>

          {/* Outils */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-semibold mb-4 text-lg">Outils</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/barometre" className="hover:text-primary-200 transition-colors">
                  Baromètre HED
                </Link>
              </li>
              <li>
                <Link to="/projector-watch" className="hover:text-primary-200 transition-colors">
                  Projector Watch
                </Link>
              </li>
              <li>
                <Link to="/align" className="hover:text-primary-200 transition-colors">
                  Align
                </Link>
              </li>
            </ul>
          </div>

          {/* Ressources */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-semibold mb-4 text-lg">Ressources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/forum" className="hover:text-primary-200 transition-colors">
                  Forum
                </Link>
              </li>
              <li>
                <Link to="/help/faq" className="hover:text-primary-200 transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about/mission" className="hover:text-primary-200 transition-colors">
                  Notre mission
                </Link>
              </li>
              <li>
                <Link to="/mentions-legales" className="hover:text-primary-200 transition-colors">
                  Mentions légales
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="font-semibold mb-4 text-lg">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="https://www.cabinet-immersion-7.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 hover:text-primary-200 transition-colors"
                >
                  <ExternalLink className="w-3 h-3" />
                  Site du cabinet
                </a>
              </li>
              <li>
                <a 
                  href="https://www.resalib.fr/praticien/78473-cabinet-immersion-7-coach-en-developpement-personnel-boissy-le-chatel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 hover:text-primary-200 transition-colors"
                >
                  <ExternalLink className="w-3 h-3" />
                  Réserver
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Mobile Footer */}
        <div className="md:hidden flex items-center justify-between">
          <img 
            src={logoI7}
            alt="Logo I7" 
            className="h-10 object-contain"
          />
          <div className="flex flex-col items-end">
            <div className="flex items-center gap-4 mb-2">
              <a 
                href="https://www.facebook.com/cabinetimmersion7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary-200 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/cabinet_immersion7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary-200 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://www.linkedin.com/company/cabinet-immersion-7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-primary-200 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
            <div className="text-xs opacity-75">
              © 2025 Cabinet Immersion 7
            </div>
          </div>
        </div>
        
        {/* Copyright - Desktop */}
        <div className="hidden md:block mt-6 pt-4 border-t border-opacity-30 text-center text-xs" style={{ borderColor: `${toolColors.secondary}` }}>
          <p>© 2025 Human & Entity Design - Cabinet Immersion 7</p>
          <p>SIRET : 884 494 683 00029</p>
        </div>
      </div>
    </motion.footer>
  );
}